import { Rule } from "antd/lib/form";

export const emailPattern: Rule = {
	pattern: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g,
	message: "Esse campo requer um e-mail válido",
};
